
export function PromoCodeBoxViewConstructor(services, _, context) {

  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementView.extend({

    isElementEditable: true,
    editElementModalController: 'editPromoCodeOperationController',
    editElementModalTemplate: require('./edit-promo-code-operation.modal.html'),

    angularTemplate: `
        <div layout="column">
          <p translate-once="parameters/quick_replies/details/promo_code/description"></p>
          <span> {{elementView.operationsMap.get(elementData.operationId) || ('parameters/quick_replies/details/promo_code/select_operation_placeholder'|translate) }} </span>
        </div>
        `,

    init: function () {
      services.PromoCodeFactory.getPromoCodeOperations(context.companyId)
        .then(({ data }) => {
          context.dropdownItems = data;
          this.operationsMap = new Map();
          (data || []).forEach(({ id, label }) => {
            this.operationsMap.set(id, label)
          });
        }, services.AlertingFactory.httpErrorHandler());

    }
  });
}
